import React from "react";
import { FormattedMessage, FormattedDate } from "react-intl";
// Displays role validity period in a human-readable format (US-02)
var RoleValidity = function (_a) {
    var validFrom = _a.validFrom, validTo = _a.validTo;
    // Normalize empty strings to null for consistent falsy checks
    var from = validFrom || null;
    var to = validTo || null;
    if (!from && !to) {
        return React.createElement(FormattedMessage, { id: "ui-czna-users.role.validity.noLimit" });
    }
    if (from && !to) {
        return (React.createElement(FormattedMessage, { id: "ui-czna-users.role.validity.from", values: { date: React.createElement(FormattedDate, { value: from }) } }));
    }
    if (!from && to) {
        return (React.createElement(FormattedMessage, { id: "ui-czna-users.role.validity.until", values: { date: React.createElement(FormattedDate, { value: to }) } }));
    }
    return (React.createElement(FormattedMessage, { id: "ui-czna-users.role.validity.range", values: {
            from: React.createElement(FormattedDate, { value: from }),
            to: React.createElement(FormattedDate, { value: to }),
        } }));
};
export default RoleValidity;
